import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const resources = [
    { label: t('home.footerSpreadsheet'), to: '/' },
    { label: t('home.footerGuides'), to: '/usfans-spreadsheet-beginner-guide' },
    { label: t('home.footerReviews'), to: '/#review' },
    { label: t('home.footerShipping'), to: '/#shipping' },
    { label: t('home.footerCoupons'), to: '/#coupons' },
    { label: t('home.footerWarehouse'), to: '/#warehouse' },
    { label: t('home.footerQC'), to: '/guide/usfans-qc-guide' },
    { label: t('home.footerSafety'), to: '/guide/usfans-safety-guide' },
    { label: t('home.footerFaq'), to: '/#faq' },
  ];

  const company = [
    { label: t('home.footerAbout'), to: '/' },
    { label: t('home.footerContact'), to: '/' },
    { label: t('home.footerEditorial'), to: '/' },
    { label: t('home.footerPrivacy'), to: '/' },
    { label: t('home.footerTerms'), to: '/' },
    { label: t('home.footerDisclaimer'), to: '/' },
  ];

  return (
    <footer className="bg-emerald-900 text-emerald-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-emerald-600 text-white flex items-center justify-center">
                <i className="ri-table-line text-lg" />
              </span>
              <span className="font-heading font-bold text-white text-base">USFans Spreadsheet</span>
            </div>
            <p className="text-sm text-emerald-100/80 max-w-sm leading-relaxed">{t('home.footerDesc')}</p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">
              <a href="/#categories" className="cursor-pointer">
                {t('home.footerResources')}
              </a>
            </h4>
            <ul className="space-y-2.5">
              {resources.map((r) =>
                r.to.startsWith('/#') ? (
                  <li key={r.label}>
                    <a href={r.to} className="text-sm text-emerald-100/80 hover:text-white cursor-pointer whitespace-nowrap">
                      {r.label}
                    </a>
                  </li>
                ) : (
                  <li key={r.label}>
                    <Link to={r.to} className="text-sm text-emerald-100/80 hover:text-white cursor-pointer whitespace-nowrap">
                      {r.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">
              <a href="/" className="cursor-pointer">
                {t('home.footerCompany')}
              </a>
            </h4>
            <ul className="space-y-2.5">
              {company.map((c) => (
                <li key={c.label}>
                  <a href={c.to} className="text-sm text-emerald-100/80 hover:text-white cursor-pointer whitespace-nowrap">
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-emerald-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-emerald-100/70">
            © {new Date().getFullYear()} USFans Spreadsheet. {t('home.footerRights')}
          </p>
          <p className="text-xs text-emerald-100/70">{t('home.footerLanguages')}: English · Polski · Español · Français</p>
        </div>
      </div>
    </footer>
  );
}